import React, {Component} from 'react';
import {MODE_BLANC, MODE_ENTRAINEMENT, TYPE_THEMATIQUE} from '../../constants';
import './SplashScreen.scss';

class SplashScreen extends Component {
  render() {
    const {mode, displayAudio, sound, toggleSound, toggleSplashScreen} = this.props;
    const soundText = sound ? "Son activé" : "Son désactivé";
    let title;
    switch (mode) {
      case MODE_ENTRAINEMENT:
        title = "Entraînement";
        break;
      case MODE_BLANC:
        title = "Mode examen";
        break;
      case TYPE_THEMATIQUE:
        title = "Mode thématique";
        break;
      default:
        title = "Solution";
    }
    let soundSwitch = null;
    if (displayAudio) {
      soundSwitch = (
        <div className='sound-switch'>
          <div className={'switch ' + (sound ? 'checked' : '')} onClick={toggleSound}>
            <span className="slider round"></span>
          </div>
          <span>{soundText}</span>
        </div>
      );
    }

    return (
      <div className='SplashScreen'>
        <h1>{title}</h1>
        <button className='btn btn-primary' onClick={toggleSplashScreen}>Démarrer la série</button>
        {soundSwitch}
      </div>
    );
  }
}

export default SplashScreen;
